import { render, staticRenderFns } from "./RequestTypeNew.vue?vue&type=template&id=7625e7b7"
import script from "./RequestTypeNew.vue?vue&type=script&lang=js"
export * from "./RequestTypeNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports